import { Dialog, IconButton, Slide, Box, AppBar, Toolbar, Typography } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import CloseIcon from '@mui/icons-material/Close';
import React, { useRef, useState } from 'react';
import TasksList from '../TasksList';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface TasksModalProps {
  open: boolean;
  onClose: () => void;
  homeId: string;
}

const TasksModal = ({ open, onClose }: TasksModalProps) => {
  const [swipeOffset, setSwipeOffset] = useState(0);
  const touchStartY = useRef(0);
  const appBarRef = useRef<HTMLDivElement>(null);
  
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartY.current = e.touches[0].clientY;
  };
  
  const handleTouchMove = (e: React.TouchEvent) => {
    const currentY = e.touches[0].clientY;
    const diff = currentY - touchStartY.current;
    
    // Only allow downward swipes
    if (diff > 0) {
      setSwipeOffset(diff);
      // Prevent scrolling while swiping down
      e.preventDefault();
    }
  };
  
  const handleTouchEnd = () => {
    // If swiped down more than 100px, close the dialog
    if (swipeOffset > 100) {
      onClose();
    }
    // Reset the offset
    setSwipeOffset(0);
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      sx={{ zIndex: 2100 }}
    >
      <Box sx={{ 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        transform: `translateY(${swipeOffset}px)`,
        transition: swipeOffset ? 'none' : 'transform 0.3s ease',
        opacity: Math.max(1 - swipeOffset / 200, 0.5)
      }}>
        <AppBar 
          position="static" 
          color="primary" 
          elevation={1} 
          sx={{ mb: 0 }}
          ref={appBarRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <Toolbar sx={{ minHeight: '56px' }}>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Home Buying Tasks
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={onClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        
        <Box sx={{ flex: 1, overflow: 'auto', p: 0 }}> {/* Remove padding */}
          <TasksList isMobileModal={true} /> {/* Add prop to identify when in mobile modal */}
        </Box>
      </Box>
    </Dialog>
  );
};

export default TasksModal;